var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCricket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cricket_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.651.664a2.375 2.375 0 0 1 3.359 0l1.326 1.326a2.375 2.375 0 0 1 0 3.359L8.68 12.005c-.564.564-1.422.871-2.25.623-.47-.141-1-.026-1.37.344l-2.913 2.913a.5.5 0 0 1-.707 0L.114 14.56a.5.5 0 0 1 0-.708l2.913-2.912c.37-.37.486-.9.345-1.37-.249-.828.059-1.686.623-2.25L9.64 1.676l.036-.035zm-.64 2.055L4.702 8.027c-.16.16-.278.35-.346.546.474-.118.997.007 1.367.378l1.326 1.326c.37.37.497.893.378 1.367a1.45 1.45 0 0 0 .546-.346l5.308-5.309zm3.977 2.563-3.27-3.27.64-.64a1.375 1.375 0 0 1 1.945 0l1.325 1.325a1.375 1.375 0 0 1 0 1.945zm-7.635 6.31a.437.437 0 0 0-.011-.608L5.016 9.658a.44.44 0 0 0-.607-.01 2.37 2.37 0 0 1-.674 1.999l-2.56 2.56.619.618 2.56-2.56a2.37 2.37 0 0 1 1.999-.674",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cricket_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgCricket;